var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('BannerHome'),_c('ProdukHome'),_c('MixProdukHome'),_c('ArtikelHome'),_c('Subscribe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }